import React from 'react';
import CommonSVGIcon, { Props } from '@/components/icons/CommonSVGIcon';

export default function (props: Props) {
  return (
    <CommonSVGIcon {...props} viewBox="0 0 20 20">
      <path d="M11.6667 6.66667C11.6667 4.825 10.175 3.33334 8.33333 3.33334C6.49167 3.33334 5 4.825 5 6.66667C5 8.50834 6.49167 10 8.33333 10C10.175 10 11.6667 8.50834 11.6667 6.66667ZM10 6.66667C10 7.58334 9.25 8.33334 8.33333 8.33334C7.41667 8.33334 6.66667 7.58334 6.66667 6.66667C6.66667 5.75 7.41667 5 8.33333 5C9.25 5 10 5.75 10 6.66667Z"/>
      <path d="M1.66666 15V16.6667H15V15C15 12.7833 10.5583 11.6667 8.33332 11.6667C6.10832 11.6667 1.66666 12.7833 1.66666 15ZM3.33332 15C3.49999 14.4083 6.08332 13.3333 8.33332 13.3333C10.575 13.3333 13.1417 14.4 13.3333 15H3.33332Z"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M19.5083 6.18333L18.325 5L15.6833 7.64167L14.5083 6.45833L13.3333 7.63333L15.6833 10L19.5083 6.18333Z"/>
    </CommonSVGIcon>
  );
}